var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-text-field",
    _vm._b(
      {
        staticClass: "custom-placeholder",
        attrs: {
          type: _vm.type,
          "hide-details": _setup.hideDetails,
          autofocus: _vm.autofocus,
          "prepend-inner-icon": _vm.prependInnerIcon,
          "append-icon": _vm.appendIcon,
          "error-messages": _vm.errorMessages,
          label: _vm.label,
          outlined: _vm.outlined,
          dense: _vm.dense,
          solo: _vm.solo,
          disabled:
            _vm.disabled ||
            (_vm.code &&
              !_setup.user &&
              !_setup.user.is_master &&
              !_setup.user &&
              !_setup.user.is_internal),
          readonly:
            _vm.readonly ||
            (_vm.code &&
              !_setup.user &&
              !_setup.user.is_master &&
              !_setup.user &&
              !_setup.user.is_internal),
          placeholder: _vm.placeholder,
          flat: _vm.flat,
          "solo-inverted": _vm.soloInverted,
          clearable: _vm.clearable,
          dark: _vm.dark,
          loading: _vm.loading,
          rules: _vm.rules,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _setup.emit("keyup-enter", $event)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "append",
              fn: function () {
                return [
                  _vm._t("append"),
                  _vm.code || _vm.textHelper
                    ? _c("emc-info-help", {
                        attrs: {
                          "icon-color": _vm.code ? "error" : "indigo",
                          title: "Informações",
                          text: _vm.textHelper
                            ? _vm.textHelper
                            : "Código externo utilizado para integração com outros sistemas. É permitido alteração apenas pelo administrador.",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "prepend-inner",
              fn: function () {
                return [_vm._t("prepend-inner")]
              },
              proxy: true,
            },
            {
              key: "append-outer",
              fn: function () {
                return [_vm._t("append-outer")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      },
      "v-text-field",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }